module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcthigh5-2b2ae4094e0ec0828738e7eabf12f953.jpg";